var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-box"},[_c('el-menu',{attrs:{"mode":"horizontal","router":true,"default-active":_vm.activeMenuIndex}},[_vm._l((_vm.mainMenus),function(menu,i){return _c('el-menu-item',{key:i,attrs:{"index":menu.path}},[_vm._v(_vm._s(menu.meta.label))])}),_c('el-menu-item',{on:{"click":_vm.jump}},[_vm._v("文档工具")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }